import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=4a926ef2&scoped=true&"
import script from "./FormSettings.vue?vue&type=script&lang=ts&"
export * from "./FormSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a926ef2",
  null
  
)

export default component.exports